<template>
  <div class="fu-step fu-step-options">
    <div class="fu-step-header">
      <button type="button" class="fu-back-btn" @click="$emit('go-back')" t_label="btn_emp2_Back_ForgotUsernameOptions">
        <img 
          src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/All_Categories.svg" 
          alt="back" 
          class="fu-back-icon"
        />
      </button>
      <h1 class="fu-step-title">{{ $t('lbl_emp2_ForgotAccountName') }}</h1>
    </div>

    <div class="fu-form-group">
      <div class="fu-info-text" v-html="$t('lbl_emp2_IfConnectedOtherLoginMethods')"></div>
    </div>

    <div class="fu-form-group">
      <AlternativeLoginButtons
        :buttons="[
          { key: 'mobile', label: $t('lbl_emp2_LoginWithMobile'), withIndicator: false },
          { key: 'email', label: $t('lbl_emp2_LoginWithEmail'), withIndicator: false }
        ]"
        @switch="$emit('switch-login', $event)"
      />
    </div>

    <Divider />

    <div class="fu-form-group">
      <div class="fu-info-text" v-html="$t('lbl_emp2_AdminCanRetrieveUsername')"></div>
    </div>

    <div class="fu-form-group">
      <AlternativeLoginButtons
        :buttons="[
          { key: 'forgot-username-mobile', label: $t('lbl_emp2_RetrieveUsernameViaMobile'), withIndicator: false },
          { key: 'forgot-username-email', label: $t('lbl_emp2_RetrieveUsernameViaEmail'), withIndicator: false }
        ]"
        @switch="$emit('switch-login', $event)"
      />
    </div>

    <Divider />

    <div class="fu-form-group">
      <div class="fu-info-text" v-html="$t('lbl_emp2_NoOtherLoginMethodsContact')"></div>
      <AlternativeLoginButtons
        :buttons="[
          { key: 'contact-us', label: $t('lbl_emp2_ContactUs'), withIndicator: false }
        ]"
        @switch="$emit('switch-login', $event)"
      />
    </div>
  </div>
</template>

<script>
import Divider from '../Common/Divider.vue';
import AlternativeLoginButtons from '../Common/AlternativeLoginButtons.vue';

export default {
  name: 'ForgotUsernameOptions',
  components: {
    Divider,
    AlternativeLoginButtons
  }
};
</script>

<style>
@import '../Common/new-login-shared.css';
</style>

<style scoped>
.fu-step-options {
  gap: 24px !important;
}
</style>

